/**
 * Created by tmorone on 2/11/2016.
 */

var Marionette = require('backbone.marionette');

module.exports = Marionette.Object.extend({
     initialize: function(options) {
        this.mode = options.mode;
     },

    info: function(message) {
        if(this.mode !== 'production') {
            var now = new Date();
            console.info(now.toLocaleTimeString() + ' info - ' + message);
        }
    },

    debug: function(message) {
        if(this.mode !== 'local') {
            var now = new Date();
            console.debug(now.toLocaleTimeString() + ' debug - ' + message);
        }
    },

    error: function(message) {
        var now = new Date();
        console.error(now.toLocaleTimeString() + ' error - ' + message);
    }

});
